
<template>
  <div v-if="consolidation">
    <!-- {{consolidation}} -->
    <div class="title">Resumo</div>
    <v-card flat style="border-radius:12px">
      <v-card-text v-if="consolidation">
        <div>
          <span class="font-weight-bold">
            Nome: 
          </span>
          <span>{{execution.name}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Modelo: 
          </span>
          <span>1- Por Pessoas</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Data e período: 
          </span>
          <span>{{$dayjs(execution.date).format('DD/MM/YYYY')}}, {{consolidation.job_interval.start}} - {{consolidation.job_interval.end}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Departamento: 
          </span>
          <span>{{execution.dep_name}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Pessoas avaliadas: 
          </span>
          <span>{{consolidation.employees.length}}</span>
        </div>
      </v-card-text>
    </v-card>
    <v-tabs
      v-model="tab"
      centered
      grow
      icons-and-text
      show-arrows
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab>
        Tabela
        <v-icon>mdi-table-large</v-icon>
      </v-tab>

      <v-tab>
        Indicadores
        <v-icon>mdi-chart-arc</v-icon>
      </v-tab>

      <v-tab>
        Pareto
        <v-icon>mdi-chart-line</v-icon>
      </v-tab>

      <v-tab>
        Comentários
        <v-icon>mdi-chat</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :value="0">
        <list-table v-if="tab==0" :headers='headers' :items='items'></list-table>
      </v-tab-item>
      <v-tab-item :value="1">
        <indicators v-if="tab==1" :total_by_cat='all_categories_in_exec' :items='items'></indicators>
      </v-tab-item>
      <v-tab-item :value="2">
        <pareto v-if="tab==2" :total_by_cat='all_categories_in_exec' :items='items'></pareto>
      </v-tab-item>
      <v-tab-item :value="3">
        <comments v-if="tab==3" :comments='comments'></comments>
      </v-tab-item>
    </v-tabs-items>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Comments from '../shared/Comments.vue'
import Indicators from '../shared/Indicators.vue'
import Pareto from '../shared/Pareto.vue'
import Api from '@/api'

export default {
  name: 'ConsolidationModel1',
  props: {
    execution: {
      type: Object,
    },
  },
  components: {
    ListTable: ()=> import('./Model1Table.vue'),
    Pareto,
    Indicators,
    Comments,
  },
  data() {
    return {
      tab: 1, 

      consolidation: null,
      all_categories: [],

      categories_with_counter: null,

      times_and_grades: [],
      total_by_emp: [],
    }
  },
  methods: {
    prepareConsolidation() {
      this.consolidation = { ...this.execution.json_attributes}
      this.getCategories()
    },
    getCategories() {
      Api.Category.index({with_deleted: 1}).then(r=>r.data).then(d=>{
        this.all_categories = [...d.map(dd=>{
          return {...dd, sum: 0 }
        })]
        this.setCategoriesWithCounter()
        this.setTimesAndGrades()
        this.addTotalToTimesAndGrades()
        this.setTotalByCatPercent()

        this.setTotalByEmployee()

      })
    },
    setCategoriesWithCounter(){
      this.consolidation.employees.forEach(emp=> {
        emp.grade_time.forEach(gt=>{
          if (gt > 0) {
            this.all_categories.find(ac => Number(ac.id) == Number(gt)).sum += 1
          }
        })
      })
    },
    setTimesAndGrades(){
      this.times_and_grades = []
      for (let idx = 0; idx < this.consolidation.all_times.length; idx++) {
        const tempo = this.consolidation.all_times[idx];
        let obj = {
          time: tempo,
        }
        for (let c_idx = 0; c_idx < this.all_categories_in_exec.length; c_idx++) {
          const cat = this.all_categories_in_exec[c_idx];
          obj={
            ...obj,
            [cat.id]: 0
          }
        }
        for (let cat = 0; cat < this.consolidation.employees.length; cat++) {
          const emp = this.consolidation.employees[cat];
          obj = {
            ...obj,
            [emp.grade_time[idx]]: (obj[emp.grade_time[idx]] || 0) + 1
          }
        }
        let {time, ...o} = obj
        let total = Object.values(o).reduce((one, all)=> Number(one)+all, 0)
        this.times_and_grades.push({...obj, total})
      }
    },
    addTotalToTimesAndGrades(){
      let by_cat = {}
      for (let idx = 0; idx < this.all_categories_in_exec.length; idx++) {
        const element = this.all_categories_in_exec[idx];
        by_cat[element.id] = element.sum
      }
      let t = Object.values(by_cat).reduce((one, all)=> Number(one)+all, 0)
      by_cat = {
        time: 'Total',
        ...by_cat,
        total: t
      }

      this.times_and_grades.push(by_cat)
    },
    setTotalByCatPercent(){
      let total = this.all_categories_in_exec.reduce((acc, one) => Number(one.sum) + acc, 0)
      this.all_categories = this.all_categories_in_exec.map(cat => {
        let percent = Number((cat.sum/total*100).toFixed(1))
        return {
          ...cat, percent
        }
      })
    },
    setTotalByEmployee(){
      this.total_by_emp = []
      for (let e_idx = 0; e_idx < this.consolidation.employees.length; e_idx++) {
        let obj = {}
        for (let c_idx = 0; c_idx < this.all_categories_in_exec.length; c_idx++) {
          const cat = this.all_categories_in_exec[c_idx];
          obj = {
            ...obj,
            [cat.id]: 0
          }
        }
        const emp = this.consolidation.employees[e_idx];
        let {grade_time, ...e} = emp
        for (let idx = 0; idx < grade_time.length; idx++) {
          const time = grade_time[idx]
          if (time > 0) {
            obj = {
              ...obj,
              [time]: (obj[time] || 0) + 1
            }
          }
        }
        obj.total = Object.values(obj).reduce((acc, one)=> acc + one, 0)
        this.total_by_emp.push({...e, grades: {...obj} })
        this.total_by_emp.push(this.calcEmpPercent({...e, grades: {...obj} }))
      }
    },
    calcEmpPercent(data){
      let {grades, ...e} = data
      let obj = {grades:{}}
      let {total, ...grade} = grades
      let not_prod_idx = 2
      let prod_idx = this.headers.length - 2
      let half_idx = Math.ceil((prod_idx - not_prod_idx)/2)+1

      for (let idx = 0; idx < this.headers.length; idx++) {
        const h = this.headers[idx];
        let v = h.value.split('grades.').pop()
        if (h.value.includes('grade')){
          if ([not_prod_idx, prod_idx, half_idx].includes(idx)){
            if (idx==not_prod_idx){
              // col 1
              obj.grades[v] = `${Math.round(grade[v]/total*100)}%`
            }else if (idx == half_idx){
              // apenas para ficar no meio das colunas
              let ks = Object.keys(grade)
              let vs = Object.values(grade)
              let v1 = this.headers[not_prod_idx+1].value.split('grades.').pop()
              let v2 = this.headers[prod_idx].value.split('grades.').pop()
              // console.log({v1, v2})
              let init_idx = ks.findIndex(k=> k==v1)
              let end_idx = ks.findIndex(k=> k==v2)
              // console.log({init_idx, end_idx})
              // console.log({vs, slice: vs.slice(init_idx, end_idx,)});
              obj.grades[v] = `${Math.round(vs.slice(init_idx, end_idx).reduce((acc, one)=> acc +one, 0)/total*100)}%`
            }else if (idx == prod_idx){
              obj.grades[v] =  `${Math.round(grade[v]/total*100)}%`
              // `${Math.round((grade[v]+grade[this.headers[idx-1].value.split('grades.').pop()])/total*100)}%`
            }
          } else {
            obj.grades[v] = null
            if (v == 'total'){
              obj.grades[v] = '100%'
            }
          }
        } else {
          obj[v] = null
        }
      }

      return obj
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.prepareConsolidation();
  },
  computed: {
    all_categories_in_exec(){
      if (this.all_categories.length){
        return this.all_categories.filter(ac=> !ac.deleted_at || (ac.deleted_at && ac.sum > 0))
      }
      return []
    },
    items(){
      if (this.consolidation && this.total_by_emp.length){
        return this.total_by_emp
      }
      return []
    },
    headers(){
      if (this.all_categories && this.all_categories.length){
        let cat_h = this.all_categories.map(cat=> {
          let {name, id, code, kind} = cat
          return {align: 'center', kind, code, text: `${code}- ${name.split('COMPLEMENTAR - ').pop()}`, value: `grades.${id.toString()}`}
        })
        let headers = [
          {text: 'Pessoa Avaliada', value: 'name'},
          {text: 'Função/Local', value: 'company_name'},
          ...cat_h,
          {text: 'Total', value: 'grades.total', align: 'center'},
        ]
        return headers
      }
      return []
    },
    comments() {
      if (this.consolidation){
        return this.consolidation.comments || []
      }
      return [] 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>